import { render, staticRenderFns } from "./ClientDropdown.vue?vue&type=template&id=f133e9c8&"
import script from "./ClientDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClientDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports